<template>
    <div class="layout-common">
        <gSwiper :arr="arr" :maxH="'inherit'"></gSwiper>
        <div class="register ">
            <Row :gutter="10" class="top">
                <Col span="18">
                <div class="title disFlex">
                    <div>CHCC2025第26届全国医院建设大会暨国际医院建设、装备及管理展览会</div>
                    <!-- <div style="margin-top: -15px;"><van-button round type="default" size="small" style="width: 90px;"
                            :class="showLang === '中文' ? 'buttonCss' : ''" @click="butChange('中文')">中文</van-button> </div>
                    <div style="margin-top: -15px;"><van-button round type="default" size="small" style="width: 90px;"
                            :class="showLang === 'English' ? 'buttonCss' : ''"
                            @click="butChange('English')">English</van-button> </div> -->
                </div>
                </Col>


                <Col span="6" class="f-tar">
                <Button shape="circle" style="border-color:#00a0e9;color:#00a0e9;">中文</Button>
                <Button shape="circle" style="margin-left:10px"
                    @click="$router.push(`/ex-register-en/register`)">English</Button>
                </Col>
            </Row>
            <registerForm ref="registerForm"></registerForm>
            <!-- <registerAddr ref="registerAddr"></registerAddr> -->

            <!-- <div class="tip-info">
        <p>注：</p>
        <p>1.标准展位转角位加收20%</p>
        <p>2.展位费外，还将收取850元注册费（含在线展商手册，展商实名胸卡，会刊百字简介，招商产品在线基础服务，现场产品检索）</p>
        <p>3.最终展位费（含税6%）=展位费+注册费</p>
      </div> -->

            <div class="f-tac submit-btn">
                <Button type="primary" size="large" @click="handleSubmit" :loading="loading">提交申请</Button>
            </div>

        </div>
    </div>
</template>

<script>
import gSwiper from "@components/gSwiper/gSwiper2.vue";
import { mapActions } from "vuex";
import registerForm from "./components/register-form.vue";
import registerAddr from "./components/register-addr.vue";
export default {
    name: 'register',
    components: {
        registerForm,
        registerAddr,
        gSwiper,
    },
    data () {
        return {
            showLang: "中文",
            loading: false,
            // arr: [{ id: 1, path: require('../../../assets/img/banner.png') }],
            arr: [{ id: 1, path: "https://synairsoft.obs.cn-north-4.myhuaweicloud.com/cloudExhibition/imgs/202502/4233ef1f9bb84054b38bf1141cbb56b0.jpg"
        }],
        };
    },
    methods: {
        ...mapActions({
            getApplyCompanyRoastCreate: 'registerdModule/getApplyCompanyRoastCreate', // 新增展会接口
        }),
        butChange (e) {

            this.showLang = e
        },
        async handleSubmit () {
            this.loading = true;
            setTimeout(() => {
                this.loading = false;
            }, 5000);
           
            let res = await this.$refs.registerForm.handleSubmit();
            this.loading = false;
            if (!res.valid) return;
            // let res1 = await this.$refs.registerAddr.handleSubmit();
           
            // console.log(res1,'22222');
            console.log('registerForm', res);
            let opt = {
                newCompany: { ...res.form },
                lists: [
                    {
                        // exhibitionId: '71F993FB-03A8-4EB3-A3F0-65C9D2D665F3',
                        // exhibitionId: '7BC55608-5C8E-48F9-A59A-B708525664D1',
                        exhibitionId: 'EFC0A7EC-B2F0-4EF6-9ED4-8114CFD528DB',
                        ...res.lists[0]
                    }],
                reportType: 'cn'
            };
            // if(res1.lists.length>0){
            //     res1.lists[0].exhibitionId="916139F0-4A1E-4C53-983B-F9BCCC4897CC"
            //     opt.lists.push(res1.lists[0])
            // }
            console.log('option', opt);
            // return

            let bool = await this.getApplyCompanyRoastCreate(opt);
            this.loading = false;
            console.log('getApplyCompanyRoastCreate', bool);
            if (bool && bool.successed) {
                // let query = 'company=' + encodeURI(res.form.companyName) + '&exname=' + encodeURI(res2.exhibition.name);
                let query = 'company=' + encodeURI(res.form.companyName);
                // this.$router.push(`/ex-register/register-result?${query}`);
                this.$router.push(`/ex-register/register-result?${query}`);
            } else {
                let errTxt = bool.msg || bool.info || "提交失败，请重新尝试！";
                if (bool.errors && bool.errors[0] && bool.errors[0].description) {
                    errTxt = bool.errors[0].description;
                }
                this.$Message.error(errTxt);
            }

        },
    },
    created () {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            this.$router.push(`/ex-register/register-mobile`);
        }
        document.title = "CHCC参展报名";
    },
}

</script>

<style lang="scss" scoped>
.layout-common {

    margin: 0 auto;
}

.register {
    max-width: 1200px;
    margin: 0 auto;

    .top {
        padding: 29px 0 15px;
    }

    .title {
        font-size: 26px;
        color: #333;
        font-weight: bold;
    }
}

.submit-btn {
    margin-top: 110px;
    text-align: center;

    button {
        padding: 0 46px;
        height: 48px;
        background-color: #1e88e5;
        font-size: 16px;
        border-color: #1e88e5;
        margin-bottom: 80px;
    }
}

.tip-info {
    width: 1200px;
    margin: 50px auto;
    color: #666;

    p {
        font-size: 12px;
        margin-bottom: 4px;
    }
}

.disFlex {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.buttonCss {
    background-color: rgb(232, 243, 252);
    border: solid 1px #1e88e5;
    color: #1e88e5;
}
</style>
